import { VERSION } from '@grafana/faro-core';
export const sdkMeta = () => ({
    sdk: {
        name: 'faro-web',
        version: VERSION,
    },
});
//# sourceMappingURL=meta.js.map